<template>
  <div
    :class="['layout', _isMobile() ? 'mobile' : '']"
    :style="{
      'background-image': 'url(' + tenantConfig.json_homeBg.image + ')',
      'background-repeat': tenantConfig.json_homeBg.repeat,
      'background-color': tenantConfig.json_homeBg.color,
      'background-size': tenantConfig.json_homeBg.size,
    }"
  >
    <Header2 v-if="tenantConfig.headerType == 2" id="header"/>
    <Header3 v-else-if="tenantConfig.headerType == 3" id="header"/>
    <Header v-else id="header"/>
    <div :class="['student-container', _isMobile() ? 'no-padding' : '']">
      <a-layout>
        <a-layout-sider v-if="!_isMobile()">
          <SideMenuStudent class="side-menu" />
        </a-layout-sider>
        <a-layout-content>
          <SideMenuStudent class="side-menu" v-if="_isMobile()" />
          <a-divider v-if="_isMobile()"></a-divider>
          <a-card :bordered="false" class="side-content">
            <router-view />
          </a-card>
        </a-layout-content>
      </a-layout>
    </div>
    <Footer />
  </div>
</template>

<script>
import Vue from "vue";
import { TENANT_CONFIG, ACCESS_TOKEN } from "@/store/mutation-types";
import { mixinDevice } from "@/utils/mixin.js";
import SideMenuStudent from "../components/SideMenuStudent.vue";
import Header from "@/components/header/Header";
import Header2 from "@/components/header/Header2";
import Header3 from "@/components/header/Header3";
import Footer from "@/components/footer/Footer";
import { jumpMixins } from "@/utils/jumpMixins";

export default {
  name: "HomeLayout",
  mixins: [mixinDevice, jumpMixins],
  components: {
    Header,
    Header2,
    Header3,
    SideMenuStudent,
    Footer,
  },
  data() {
    return {
      tenantConfig: {},
    };
  },
  created() {
    if (!Vue.ls.get(ACCESS_TOKEN)) {
      this.toLogin();
    }
    this.tenantConfig = this.$store.getters.tenantInfo;
  },
};
</script>

<style lang="less" scoped>
.layout {
  background: #f2f6f8;
  background: url(/assets/background.svg);
  min-height: 100vh;
  display: flex;
  flex-direction: column;
  .student-container {
    flex:1 1 auto;
    width: 100%;
    max-width: 1200px;
    margin: 10px auto;
    padding: 20px 30px;
    background: #ffffffd1;
    border-radius: 30px;
  }
  .no-padding {
    padding: 0 !important;
  }
  .ant-layout {
    background: transparent;
  }
  .ant-layout-sider {
    background: transparent;
  }
  .side-menu {
    background: #fff;
    text-align: center;
    border-radius: 10px;
  }
  .side-content{
    width: 100%;
  }
  .ant-card {
    margin: 0 20px;
    background: #fff;
  }
}
</style>